import React, { useState } from "react"
import { useMutation } from "@apollo/client"
import {
  RoundedButton,
  Input,
  CustomMaskedInput,
  Shimmer,
} from "@omnichannel/egr-common-ui"
import styled from "styled-components"
import { ADD_LOYALTY, GET_CUSTOMER_LOYALTY_QUERY } from "../gql/loyalty"
import withApolloClient from "../withApolloClient"

const BaseBox = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
`

const MainBox = styled(BaseBox)`
  padding: 4rem 1.2rem 3rem 1.2rem;
  flex-direction: column;
`

const FormBox = styled.div`
  flex-direction: column;
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: flex-start;
`

const InputBox = styled.div`
  display: flex;
  width: 100%;
  margin-bottom: 1rem;
  z-index: ${props => (props.zIndexValue ? props.zIndexValue : "0")};
`

const NetworkErrorBox = styled(BaseBox)`
  color: red;
  font-size: 1.4rem;
  padding: 0.4rem;
`

const ButtonBox = styled(BaseBox)`
  position: relative;
  width: auto;
  width: 12rem;
  margin: 2rem 0 1rem 0;
`

const ShimmerWrapperBox = styled(BaseBox)`
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1;
`

function LoyaltyForm(props) {
  const defautlFormValues = {
    name: "",
    cardNumber: "",
  }

  const [formValues, setFormValues] = useState(defautlFormValues)
  const [errors, setErrors] = useState({})
  const [addNetworkError, setAddNetworkError] = useState(false)
  const [inProgress, setInProgress] = useState(false)

  const [addLoyalty, loading] = useMutation(ADD_LOYALTY, {
    fetchPolicy: "no-cache",
    refetchQueries: [{ query: GET_CUSTOMER_LOYALTY_QUERY }],
    onCompleted: result => {
      // console.log("addloyalty result::", result.addLoyalty)
      if (result && !result.addLoyalty.isValid) {
        setErrors({ ...errors, ["cardNumber"]: result.addLoyalty.errorMessage })
      } else {
        props.openNotification("Loyalty Card Added!")
        props.setOpenLoyaltyModal(false)
        setFormValues(defautlFormValues)
      }
      setInProgress(false)
    },
    onError: err => {
      console.log("result::", err)
      setAddNetworkError(true)
      setInProgress(false)
      // setDisableProceedToCheckoutBtn(false)
    },
  })

  const handleChange = event => {
    const { id, value } = event.target
    // console.log("id ,value", id, "::", value, event.target)

    setFormValues({ ...formValues, [id]: value })
    setErrors({ ...errors, [id]: "" })
    setAddNetworkError(false)
  }

  const cleanCardNumber = number => {
    if (!number) {
      return ""
    }
    let newNumber = number
    newNumber = newNumber.split("-").join("")
    // console.log("newNumber::", newNumber)
    newNumber = newNumber.replace(/_/g, "")
    return newNumber
  }

  const handleSave = () => {
    setAddNetworkError(false)
    let { name, cardNumber } = formValues

    let errors = {}
    if (!name) {
      errors.name = "required"
    }
    if (!cardNumber) {
      errors.cardNumber = "required"
    } else {
      if (cleanCardNumber(cardNumber).length < 16) {
        errors.cardNumber = "Invalid card number"
      }
    }

    console.log("errors? ", errors, name, cleanCardNumber(cardNumber))

    if (Object.keys(errors).length > 0) {
      console.log("have errors")
      setErrors(errors)
    } else {
      console.log("addLoyalty")
      setInProgress(true)
      addLoyalty({
        variables: {
          cardNumber: cleanCardNumber(cardNumber),
          name: name,
        },
      })
    }
  }

  return (
    <MainBox>
      <FormBox>
        <InputBox>
          <Input
            label="Name *"
            placeholder="Name"
            value={formValues.name}
            id="name"
            onChange={handleChange}
            error={errors.name}
          />
        </InputBox>
        <InputBox>
          <CustomMaskedInput
            type="number"
            label="SMAC / PRESTIGE *"
            maskChar="_"
            mask="0000-0000-0000-0000"
            placeholder="0000-0000-0000-0000"
            value={formValues.cardNumber}
            onChange={event => {
              const cardNumber = { target: {} }
              cardNumber.target = {}
              cardNumber.target.value = event.target.value
              cardNumber.target.id = "cardNumber"
              handleChange(cardNumber)
            }}
            id="cardNumber"
            error={errors.cardNumber}
            // style={{ marginTop: ".1rem", }}
            inputPadding={"1.2rem 1.2rem"}
          />
        </InputBox>
      </FormBox>
      <NetworkErrorBox>
        &nbsp;{addNetworkError ? "Ooops! Something went wrong." : ""}
      </NetworkErrorBox>
      <ButtonBox>
        {!inProgress && (
          <RoundedButton
            margin={"0 .8rem 0 .8rem"}
            width="100px"
            textColor={"#FFF"}
            color={"#5284bd"}
            onClick={handleSave}
          >
            Add
          </RoundedButton>
        )}
        {inProgress && <Shimmer width={"10rem"} height={"4rem"} />}
      </ButtonBox>
    </MainBox>
  )
}

export default withApolloClient(LoyaltyForm, { client: "wishlistClient" })
